import ReactDOM from 'react-dom';
import App from './App';
import './assets/fonts/Roboto/Roboto-Regular.ttf';
import './index.css';

ReactDOM.render(<App />, document.getElementById('root'));

//   <React.StrictMode>
//   </React.StrictMode>,
